<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M400 128C391.2 128 384 120.8 384 112C384 103.2 391.2 96 400 96L480 96C533 96 576 139 576 192L576 448C576 501 533 544 480 544L400 544C391.2 544 384 536.8 384 528C384 519.2 391.2 512 400 512L480 512C515.3 512 544 483.3 544 448L544 192C544 156.7 515.3 128 480 128L400 128zM68.7 331.3C62.5 325.1 62.5 314.9 68.7 308.7L212.7 164.7C218.9 158.5 229.1 158.5 235.3 164.7C241.5 170.9 241.5 181.1 235.3 187.3L118.6 304L400 304C408.8 304 416 311.2 416 320C416 328.8 408.8 336 400 336L118.6 336L235.3 452.7C241.5 458.9 241.5 469.1 235.3 475.3C229.1 481.5 218.9 481.5 212.7 475.3L68.7 331.3z"
      fill="currentColor"
    />
  </svg>
</template>